import axios from 'axios';

export default {
	getPlans(showDeleted) {
		return axios.get(`/api/rotations?deleted=${showDeleted}`);
	},
	createPlan(plan) {
		return axios.post('/api/rotations/', plan);
	},
	updatePlan(planId, plan) {
		return axios.patch(`/api/rotations/${planId}`, plan);
	},
	deletePlan(planId) {
		return axios.delete(`/api/rotations/${planId}`);
	},
};
